import { render, staticRenderFns } from "./ListOfSubcategories.vue?vue&type=template&id=2c213884&"
import script from "./ListOfSubcategories.vue?vue&type=script&lang=js&"
export * from "./ListOfSubcategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports